import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=18fb5004&scoped=true&"
import script from "./MainHeader.vue?vue&type=script&lang=js&"
export * from "./MainHeader.vue?vue&type=script&lang=js&"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=18fb5004&lang=less&scoped=true&"
import style1 from "./MainHeader.vue?vue&type=style&index=1&id=18fb5004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fb5004",
  null
  
)

export default component.exports